export const TOWKNS_NAME = "Towkns";
